var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.workflow.type.component,{tag:"component",attrs:{"workflow":_vm.workflow},on:{"success":_vm.success,"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }